<template>
<div class="foot-page">
    <div class="foot">
      <div class="foot-top">
       <div class="foot-left">
        <img class="foot-lt" src="../assets/2023logoImage/logo-b.png" alt="">
        <div class="foot-wx">
          <img src="@/assets/2023logoImage/erweima.png" alt="">
        </div>
        <div class="foot-ws"></div>
       </div>
       <div class="foot-zhong">
        <h3 class="foot-zhong-lian" v-if="isSmallScreen===false">联系我们</h3>
        <p class="foot-zhong-s">商务合作：<span class="foot-zhong-r">support@ai4c3.com</span></p>
        <p class="foot-zhong-s">咨询电话：<span class="foot-zhong-r">+86 400-638-5060</span></p>
        <p class="foot-zhong-s">公司地址：<span class="foot-zhong-r">上海</span></p>
       </div>
       <div class="foot-right">
        <h3 class="foot-right-q">全国联系热线</h3>
        <p class="font-right-si">400-638-5060</p>
        <p class="font-right-z">周一到周五  9:00-18:00  (北京时间)</p>
       </div>
      </div>
      <div class="foot-bottom">
        <div class="foot-tan">上海探尔科技有限公司 | <span @click="addw"> 沪ICP备2023018723号-1</span></div>
        <div class="foot-tan">Copyright@2023 www.ai4c3.com.All Rights Reserved. </div>
      </div>
    </div>
</div>
</template>
<script>
export default {
  name: 'footers',
  data () {
    return {
      isSmallScreen: false,
      dialogVisible: false
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
    }
  },
  methods: {
    addw () {
      window.open('https://beian.miit.gov.cn/', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.foot{
  position: relative;
  top: 1100px;
  margin-top: -1100px;
  left: 0;
  width: 100%;
  height: 377px;
  background-color: #031216;
  opacity: 1.9;
  background-image: url('../assets/2023logoImage/footerdt.png');
  color: #fff;
}
.foot-lt{
  width: 280px;
  height: 73px;
  position: absolute;
  top: 80px;
  left: 250px;
}
.foot-wx{
  width: 40px;
  height: 40px;
  background-image: url('../assets/2023logoImage/erweima.png');
  position: absolute;
  left: 250px;
  top: 250px;
}
.foot-zhong{
  position: absolute;
  top: 90px;
  left: 623px;
}
.foot-zhong-lian{
  font-size: 22px;
  margin-bottom: 50px;
}
.foot-zhong-s{
  font-size: 16px;
  margin-bottom: 20px;
}
.foot-right{
  position: absolute;
  top: 90px;
  right: 230px;
}
.foot-right-q{
  font-size: 22px;
  margin-bottom: 50px;
}
.font-right-si{
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 30px;
}
.foot-zhong-r{
  margin-left: 20px;
}
.foot-top{
  height: 340px;
  border-bottom: 1px solid #7d7777;
}
.foot-tan{
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin-top: 5px;
  margin-bottom:5px ;
}
.foot-bottom{
  cursor: pointer;
}
@media screen and (max-width:1000px) and (min-width:768px) {
.foot{
  margin-top:-595px ;
  position: relative;
  top: 600px;
  left: 0;
  width: 100%;
  height: 275px;
  background-color: #031216;
  opacity: 1.9;
  background-image: url('../assets/2023logoImage/footerdt.png');
  background-size: 100% 100%;
  background-repeat: repeat;
  color: #fff;
}
.foot-lt{
  width: 18%;
  height: 14%;
  position: absolute;
  top: 21%;
  left: 5%;
}
.foot-wx{
  width: 80px;
  height: 80px;
  background-image: url('../assets/2023logoImage/erweima.png');
  position: absolute;
  left: 5%;
  top: 41%;
}
.foot-zhong{
  position: absolute;
  top: 22%;
  left: 50%;
  transform: translate(-50%);
}
.foot-zhong-lian{
  font-size: 10%;
  margin-bottom:5% ;
}
.foot-zhong-s{
  font-size: 16px;
  margin-bottom:3% ;
}
.foot-right{
  position: absolute;
  top: 23%;
  right: 2%;
}
.foot-right-q{
  font-size: 10%;
  margin-bottom:5% ;
}
.font-right-si{
  font-size: 12%;
  font-weight: 600;
  margin-bottom:2% ;
}
.foot-zhong-r{
  margin-left: 2%;
}
.foot-top{
  height: 203px;
  border-bottom: 1px solid #7d7777;
}
.foot-tan{
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin-top: 2px;
  margin-bottom:0px ;
  position: relative;
  left: 0;
  top: 321px;
}
.foot-bottom{
  top: -114px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
}
@media (max-width: 767px) {
.foot{
  margin-top: -1084px;
  position: relative;
  width: 100%;
  height: 325px;
  background-color: #252625;
  background-image: url();
  color: #fff;
}
.foot-lt{
  width: 140px;
  height: 36.5px;
  position: absolute;
  top: 25px;
  left: 15px;
}
.foot-wx{
  width: 100px;
  height: 100px;
  // background-image: url('../assets/2023logoImage/erweima.png');
  // background-size: cover;
  position: absolute;
  left: 70%;
  top: 33%;
}
.foot-right{
  position: absolute;
  left: 14px;
  top: 78px;
  .foot-right-q{
    font-size: 12px;
    margin-bottom: 10px;
  }
  .font-right-z{
    width: 200%;
    margin-top: -26px;
    font-size: 12px;
    color: #bdbebd;
  }
  .font-right-si{
    font-size: 20px;
  }
}
.foot-zhong{
  position: absolute;
  left: 14px;
  top: 176px;
  .foot-zhong-s{
    font-size: 12px;
    margin-bottom: 5px;
  }
  .foot-zhong-r{
    margin-left: 0px;
  }
}
.foot-top{
  height: 255px;
  border-bottom: 1px solid #7d7777;
}
.foot-tan{
    text-align: center;
    font-size: 12px;
    color: #fff;
    margin-top: 5px;
    margin-bottom: 5px;
    position: relative;
    left: 0;
    top: 3px;
}
}
</style>
